import { OnInit, Directive } from '@angular/core';
import { BaseModel } from '../../models/base.model';
import { Page } from 'src/app/models/page.model';
import { BaseService } from '../../services/base.service';

@Directive()
export abstract class BaseFormListComponent<T extends BaseModel> implements OnInit {

    resources: Page<T>;

    constructor(private baseService: BaseService<T>) {}

    ngOnInit(): void {
        this.baseService.getAll()
            .subscribe(resource => {
              this.resources = resource;
      });
    }

    deleteResource(resource: T) {
        const mustDelete = confirm('Deseja realmente excluir este item?');

        if (mustDelete) {
          this.baseService.delete(resource.id)
          .subscribe(
            () => this.resources.items = this.resources.items.filter(element => element !== resource),
            () => alert('Erro ao tentar excluir!')
          );
        }
    }

}
